export default "__VITE_ASSET__DNiS$J8p__"